import { injectStrict } from '@/injection/injectStrict.ts';
import { ApiKey } from '@/injection/keys.ts';
import { ApiRequestParams } from '@/types/api.type.ts';
import { FeedbackFormErrors, FeedbackFormErrorsSchema } from '@/types/feedback';

class FeedbackRepository
{
    private $Api: any;

    constructor() {
        this.$Api = injectStrict(ApiKey);
    }

    public sendFeedback(form: FormData): Promise<void>
    {
        const requestParams: ApiRequestParams = {
            requestBody: form,
        };

        return new Promise((resolve, reject) => {
            this.$Api.callNew('SendFeedback', requestParams)
                .then(() => resolve())
                .catch(({ response: { status, data: { errors } } }: any) => {
                    if (status === 422) {
                        const parsedErrors = FeedbackFormErrorsSchema.parse(errors);
                        const formErrors: FeedbackFormErrors = parsedErrors as unknown as FeedbackFormErrors;

                        reject(formErrors);
                    }
                });
        });
    }
}

export default FeedbackRepository;
